<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-non-bodymatter element-type-epigraph element-without-heading" id="intro-to-memorial">
<div class="text" id="intro-to-memorial-text">
<p class="first first-in-chapter first-full-width"><i>Why not start at the beginning? I’ll open this initial volume with my very first published story, a short that I wrote on a manual typewriter when I was a sophomore in high school. It was 1977, and I had already wanted to be a writer for years.</i></p>
<p class="subsq"><i>When digging through old boxes and files a few months ago, I came upon my high school scrapbooks and found the magazine that printed the story, a Wisconsin High School Writings publication. I was 14 years old.</i></p>
<p class="subsq"><i>Maybe Steven Spielberg will see it now and decide to make it into an epic $200M film! Or maybe not. Nevertheless, I was off and running.</i></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// introtomemorial.vue?494a8562